import React from "react";
import { Button, Modal } from "react-bootstrap";
import { QRCodeSVG } from "qrcode.react";
import bdsleepLogo from "../../../images/logo/logo_sq.png";

const PatientFormQrModal = ({ qrData, onHide }) => {
  if (!qrData || !qrData.url) return null;

  return (
    <Modal show={Boolean(qrData)} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>QR Code for Patient Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row align-items-center">
          <div className="col-md-7 mb-3 mb-md-0">
            <h5 className="mb-3">{qrData.formName}</h5>
            <dl className="row mb-0">
              {qrData.order && (
                <>
                  <dt className="col-sm-4">Order</dt>
                  <dd className="col-sm-8">{qrData.order}</dd>
                </>
              )}
              <dt className="col-sm-4">Patient</dt>
              <dd className="col-sm-8">{qrData.patientName || "-"}</dd>
              <dt className="col-sm-4">HN</dt>
              <dd className="col-sm-8">{qrData.hn || "-"}</dd>
              <dt className="col-sm-4">Status</dt>
              <dd className="col-sm-8">
                <span
                  className={
                    qrData.submitted
                      ? "badge badge-success"
                      : "badge badge-warning text-white"
                  }
                  style={{ color: "#fff" }}
                >
                  {qrData.submitted ? "Submitted" : "Not submitted"}
                </span>
              </dd>
            </dl>
            <p className="text-muted mb-0">
              Let the patient scan this code to open their form.
            </p>
            <div className="alert alert-light border mt-3 mb-0 py-2 small">
              <strong>Need English?</strong>
              <ol className="mb-0 pl-3">
                <li>Open the form in Google Chrome on your phone.</li>
                <li>Select <strong>Translate</strong>, then choose <strong>English</strong>.</li>
              </ol>
            </div>
          </div>
          <div className="col-md-5 text-center">
            <div className="d-inline-block border rounded bg-white p-3">
              <QRCodeSVG
                value={qrData.url}
                size={240}
                level="H"
                marginSize={4}
                title={qrData.formName}
                imageSettings={{
                  src: bdsleepLogo,
                  width: 48,
                  height: 48,
                  excavate: true,
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <a
          className="btn btn-outline-primary"
          href={qrData.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Form
        </a>
        <Button variant="light" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PatientFormQrModal;
